import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { ApiService } from '../../services/api/api.service';
import { InvalidateTokens, InvalidateTokensFailed, InvalidateTokensSuccess } from '../actions';

@Injectable()
export class TokenEffects {
    constructor(private actions$: Actions, private _api: ApiService) {}

    invalidateActiveTokens$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(InvalidateTokens),
            mergeMap(action => {
                return this._api.common.invalidateTokens(action.payload).pipe(
                    map((response: { msg: string }) =>
                        InvalidateTokensSuccess({
                            msg: response.msg,
                        })
                    ),
                    catchError(errorResponse =>
                        of(
                            InvalidateTokensFailed({
                                msg: errorResponse.msg,
                            })
                        )
                    )
                );
            })
        );
    });
}
